import {
  setCategories,
  setGlobalSearchList,
  setAgencies,
  setIsRootLoading,
  setMetaLanguage,
  setOrgBusTeamConstants,
  setBusinessProductConstants,
  setUserSocialChannels,
  setProductList,
  setBusinesses,
  setNotifications,
  setCurrentSocial,
  setYoutubePlaylist,
  setCategory,
  setLanguage,
  setCast,
  setTag,
  setGenre,
  setConstUserList,
  setAgencyList,
} from "./app.slice";

import {
  GetConstantsApi,
  GetYoutubePlaylistAPI,
  GetNotificationsListAPI,
  UpdateSocialChannelsApi,
  UpdatePlaylistApi,
  DeleteSocialChannelsApi,
  DeleteSocialPublishApi,
  TakedownSocialPublishApi,
  TranslateTitleApi,
  DeleteTranscriptApi,
  ReadNotificationAPI,
  DisapproveServiceRequestAPI,
  ApproveServiceRequestAPI,
  GlobalSearchListMediasApi,
} from "@/database";
import { Dispatch } from "redux";
import { RootState } from "..";
import { toast } from "../../components";
import { setMediaDetails } from "../media/media.slice";

import { GetSocialChannelAPI } from "@/database";
import { AI_PROMPT_TITLE, AI_PROMPT_DESC } from "../../utils";

export const getListConstants =
  (): any => async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      const response = await GetConstantsApi();

      if (response.status && response.status === 200) {
        dispatch(setOrgBusTeamConstants(response?.data?.orgMap));
        dispatch(
          setBusinessProductConstants(response?.data?.businessProductMap)
        );
        dispatch(setCategories(response?.data?.categories));
        dispatch(setMetaLanguage(response?.data?.metaLanguage));
        dispatch(setCategory(response?.data?.category));
        dispatch(setLanguage(response?.data?.language));
        dispatch(setTag(response?.data?.tag));
        dispatch(setCast(response?.data?.cast));
        dispatch(setGenre(response?.data?.genre));
        dispatch(setProductList(response?.data?.teams));
        dispatch(setBusinesses(response?.data?.businesses));
        dispatch(setAgencies(response?.data?.agencies));
        dispatch(setConstUserList(response?.data?.constUserList));
        dispatch(setAgencyList(response?.data?.agencyList));

        dispatch(setIsRootLoading(false));
      } else {
        console.warn("Constants API returned non-200 status:", response.status);
        dispatch(setIsRootLoading(false));
      }
    } catch (error) {
      console.error("Error fetching constants:", error);
      dispatch(setIsRootLoading(false));
    }
  };

export const getYoutubePlaylist =
  (channel_id: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setYoutubePlaylist({ isLoading: true }));
    const response = await GetYoutubePlaylistAPI(channel_id);
    dispatch(
      setYoutubePlaylist({
        isLoading: false,
        error: response.error,
        data: response.data,
      })
    );
  };

export const updatePlaylist =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await UpdatePlaylistApi(params);
    dispatch(
      setYoutubePlaylist({
        isLoading: false,
        error: response.error,
        data: response.data,
      })
    );
    if (response.status && response.status === 200) {
      //
    } else {
      toast.fail("");
    }
  };

export const getGlobalSearch =
  (params: Record<string, any>) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      //Adding id in the query as well

      const response = await GlobalSearchListMediasApi({
        title: params.title,
      });

      if (response.status && response.status === 200) {
        dispatch(setGlobalSearchList({ list: response.data || [] }));
      }
    } catch (error) {
      console.error("Error fetching media list:", error);
    }
  };

export const getSocialChannels =
  () => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setUserSocialChannels({ isLoading: true }));
    const response = await GetSocialChannelAPI(100);
    dispatch(
      setUserSocialChannels({
        isLoading: false,
        error: response.error,
        data: { list: response.data },
      })
    );
  };
export const getNotifications =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setNotifications({ isLoading: true }));
    const response = await GetNotificationsListAPI(params);
    dispatch(
      setNotifications({
        isLoading: false,
        error: response.error,
        list: response.data,
      })
    );
  };

export const approveServiceRequest =
  (id: number, service: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await ApproveServiceRequestAPI(id, service);
  };

export const disapproveServiceRequest =
  (id: number) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DisapproveServiceRequestAPI(id);
  };
export const readNotification =
  (params: { ids: string[]; read: number; status?: number }) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await ReadNotificationAPI(params);
    if (response.error) {
      dispatch(
        setNotifications({
          isLoading: false,
          error: response.error,
          list: getState().app.notifications.list,
        })
      );
      return;
    }
    const currentList = getState().app.notifications.list || [];
    const updatedList = currentList.map((notification: any) => {
      if (params.ids.includes(notification.id)) {
        return {
          ...notification,
          read: params.read,
        };
      }
      return notification;
    });
    dispatch(
      setNotifications({
        isLoading: false,
        error: null,
        list: updatedList,
      })
    );
  };

export const updateSocialChannel =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    // Send the API request to update the social channel data
    const response = await UpdateSocialChannelsApi(params);
    if (response?.data) {
      dispatch(setCurrentSocial({ ...response.data, id: params.id }));
    } else {
      toast.fail("");
    }
  };
export const deleteSocialChannel =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DeleteSocialChannelsApi(params);
    if (response.error === "") {
      const updatedChannels =
        getState().app.userSocialChannels.socialChannelsList.filter(
          (channel: any) => channel.id !== params.id
        );
      dispatch(
        setUserSocialChannels({
          data: { list: updatedChannels },
          isLoading: false,
        })
      );
    } else {
      toast.fail("");
    }
  };

export const deleteSocialPublish =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DeleteSocialPublishApi(params);
    if (response.error === "") {
      const currentMediaDetails = getState().media.mediaDetails.media;
      if (currentMediaDetails && currentMediaDetails.socials) {
        const updatedSocials = currentMediaDetails.socials.filter(
          (social: any) => {
            return social.id !== params.id;
          }
        );
        dispatch(
          setMediaDetails({
            data: {
              media: {
                ...currentMediaDetails,
                socials: updatedSocials,
              },
            },
          })
        );
      }
    } else {
      toast.fail("");
    }
  };

export const takedownSocialPublish = (params: any) => async () => {
  const response = await TakedownSocialPublishApi(params);
  if (response.error !== "") {
    toast.fail("");
  }
  return response;
};

export const aiService =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await TranslateTitleApi({
      service: params.service === "transcript" ? "transcript" : "prompt",
      input: params.service === "transcript" ? params.id : params.title,
      id: params.id,
      // prompt: AI_PROMPT_TITLE[params.service as keyof typeof AI_PROMPT_TITLE],
      prompt:
        params.service === "prompt"
          ? params.target_language
          : params.service === "Short & Concise"
          ? params.type === "title"
            ? AI_PROMPT_TITLE["Short & Concise"]
            : AI_PROMPT_DESC["Short & Concise"]
          : params.service === "Factual"
          ? params.type === "title"
            ? AI_PROMPT_TITLE["Factual"]
            : AI_PROMPT_DESC["Factual"]
          : params.service === "Conversational"
          ? params.type === "title"
            ? AI_PROMPT_TITLE["Conversational"]
            : AI_PROMPT_DESC["Conversational"]
          : params.service === "Dramatic"
          ? params.type === "title"
            ? AI_PROMPT_TITLE["Dramatic"]
            : AI_PROMPT_DESC["Dramatic"]
          : params.service === "Viral"
          ? params.type === "title"
            ? AI_PROMPT_TITLE["Viral"]
            : AI_PROMPT_DESC["Viral"]
          : params.service === "translate"
          ? `Translate this text to ${params.target_language}`
          : "",
    });
    return response.data;
  };

export const deleteTranscript =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DeleteTranscriptApi(params);
    return response.data;
  };

export const translateTitleUrl =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await TranslateTitleApi({
      service: "prompt",
      input: params.title,
      id: params.id,
      for: "title_for_url",
      prompt: "translate this text to english",
    });
    return response.data.output_processed.output;
  };
